import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { environment } from '../environments/environment';
import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { ChartsModule } from 'ng2-charts';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      // mode: 'ios'
    }),
    AppRoutingModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    ChartsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAnalytics(() => getAnalytics()),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore())
    // provideAuth(() => getAuth()),
    // provideStorage(() => getStorage()),
    // provideFirebaseApp(() => initializeApp({
    //   apiKey: 'AIzaSyAagx0axqNEUuojS9uE3TAN4Qtglh2rrYQ',
    //   authDomain: 'baby-tracker-app-d48b3.firebaseapp.com',
    //   projectId: 'baby-tracker-app-d48b3',
    //   storageBucket: 'baby-tracker-app-d48b3.appspot.com',
    //   messagingSenderId: '504371268080',
    //   appId: '1:504371268080:web:ac04a59d1912e39a9e3535',
    //   measurementId: 'G-JPRYDJX0D7'
    // })),
    // provideFirestore(() => getFirestore())
  ],
  providers: [
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
    ScreenTrackingService, UserTrackingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
